var map = {
	"./en/banks.json": 1309,
	"./en/errors.json": 1310,
	"./en/main.json": 1311,
	"./en/types.json": 1312,
	"./fa/banks.json": 1313,
	"./fa/errors.json": 1314,
	"./fa/main.json": 1315,
	"./fa/types.json": 1316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1308;